
import React, { useEffect } from 'react';

const MobileEnhancer: React.FC = () => {
  useEffect(() => {
    // Enhanced mobile viewport setup for app-like experience
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes, viewport-fit=cover, shrink-to-fit=no'
      );
    }

    // Add mobile-specific meta tags for app-like experience
    const mobileWebAppCapable = document.createElement('meta');
    mobileWebAppCapable.name = 'mobile-web-app-capable';
    mobileWebAppCapable.content = 'yes';
    document.head.appendChild(mobileWebAppCapable);

    const appleWebAppCapable = document.createElement('meta');
    appleWebAppCapable.name = 'apple-mobile-web-app-capable';
    appleWebAppCapable.content = 'yes';
    document.head.appendChild(appleWebAppCapable);

    const appleWebAppStatusBar = document.createElement('meta');
    appleWebAppStatusBar.name = 'apple-mobile-web-app-status-bar-style';
    appleWebAppStatusBar.content = 'black-translucent';
    document.head.appendChild(appleWebAppStatusBar);

    // Mobile performance optimizations
    const style = document.createElement('style');
    style.textContent = `
      /* Enhanced mobile scrolling and app-like feel */
      html {
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        height: -webkit-fill-available;
        overflow-x: hidden;
      }
      
      body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        overscroll-behavior: none;
        min-height: 100vh;
        min-height: -webkit-fill-available;
        overflow-x: hidden;
        user-select: none;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: transparent;
      }
      
      /* Enhanced touch targets for mobile app experience */
      button, a, [role="button"], [role="tab"] {
        min-height: 44px;
        min-width: 44px;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
      }
      
      /* Mobile-specific optimizations */
      @media (max-width: 768px) {
        .container {
          padding-left: 1rem;
          padding-right: 1rem;
        }
        
        /* Optimize images for mobile */
        img {
          max-width: 100%;
          height: auto;
          loading: lazy;
          image-rendering: -webkit-optimize-contrast;
        }
        
        /* Enhanced mobile navigation */
        .mobile-nav {
          transform: translateZ(0);
          will-change: transform;
          backface-visibility: hidden;
        }
        
        /* Prevent zoom on input focus */
        input, textarea, select {
          font-size: 16px !important;
          transform: translateZ(0);
        }
        
        /* App-like scrolling */
        * {
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
        }
      }
      
      /* Safe area handling for notched devices */
      @supports (padding: max(0px)) {
        .safe-area-inset {
          padding-left: max(1rem, env(safe-area-inset-left));
          padding-right: max(1rem, env(safe-area-inset-right));
        }
      }
    `;
    document.head.appendChild(style);

    // Enhanced mobile detection and optimization
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    if (isMobile) {
      document.body.classList.add('is-mobile');
      
      if (isIOS) {
        document.body.classList.add('is-ios');
      }
      
      // Optimize scrolling for mobile
      document.addEventListener('touchstart', () => {}, { passive: true });
      document.addEventListener('touchmove', () => {}, { passive: true });
      document.addEventListener('touchend', () => {}, { passive: true });
      
      // Prevent double-tap zoom
      let lastTouchEnd = 0;
      document.addEventListener('touchend', (event) => {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    }

    return () => {
      if (style.parentNode) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return null;
};

export default MobileEnhancer;
